<template>
  <reset-password-form-card></reset-password-form-card>
</template>

<script>
import ResetPasswordFormCard from '@/components/default/reset-password/ResetPasswordFormCard'

export default {
  name: "ResetPassword",
  components: {
    ResetPasswordFormCard
  }
}
</script>

<style scoped>

</style>